module.exports = __webpack_public_path__ + "media/images/pic/brodno/kamila-bandurska-0fcaf82fce5d242ff0f8c58437221fca.png";